export const RECOMMENDATIONS_ENDPOINT = '/recommendations';
export const SHIPPING_ADDRESS_ENDPOINT = '/shipping-cost';
export const PRODUCTS_ENDPOINT = '/products';
